import { colors } from '../styles/colors';

export const generateColors = rgbString => {
  const rgbToHex = (r, g, b) => {
    return (
      '#' +
      [r, g, b]
        .map(x => {
          const hex = x.toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        })
        .join('')
    );
  };

  // "Наложить" цвет с альфой на белый фон
  const applyAlphaToWhite = (r, g, b, alpha) => {
    const blend = channel => Math.round((1 - alpha) * 255 + alpha * channel);
    return {
      r: blend(r),
      g: blend(g),
      b: blend(b),
    };
  };

  const [r, g, b] = rgbString.split(',').map(Number);

  if (
    isNaN(r) ||
    isNaN(g) ||
    isNaN(b) ||
    r < 0 ||
    r > 255 ||
    g < 0 ||
    g > 255 ||
    b < 0 ||
    b > 255
  ) {
    throw new Error(
      'Некорректные значения RGB. Используйте формат "r, g, b" где r, g, b - числа от 0 до 255'
    );
  }

  const mixColors = (color1, color2, weight) => {
    return Math.round(color1 * weight + color2 * (1 - weight));
  };

  const main = rgbToHex(r, g, b);

  const lightR = mixColors(r, 255, 0.15);
  const lightG = mixColors(g, 255, 0.15);
  const lightB = mixColors(b, 255, 0.15);
  const light = rgbToHex(lightR, lightG, lightB);

  const lighter = rgbToHex(255, 228, 225);
  const disabled = rgbToHex(204, 204, 204);

  // Применяем альфу (0.4) к цвету, накладывая на белый фон
  const alpha = 0.4;
  const blended = applyAlphaToWhite(lightR, lightG, lightB, alpha);
  const backend = rgbToHex(blended.r, blended.g, blended.b);

  const root = document.documentElement;
  root.style.setProperty('--color-primary', main);
  root.style.setProperty('--color-primary-light', light);
  root.style.setProperty('--color-primary-lighter', lighter);
  root.style.setProperty('--color-disabled', disabled);
  root.style.setProperty('--color-backend', backend);

  colors.primary.main = main;
  colors.primary.light = light;
  colors.primary.lighter = lighter;
  colors.primary.disabled = disabled;
  colors.background.backend = backend;
};
